export const toParagraphs = (text: string): string[] => text
    .trim()
    .split(/\r?\n\s*\r?\n/u)
    .map(p => p
        .replace(/\r?\n/gu, ' ')
        .replace(/\s{2,}/gu, ' ')
        .trim())
    .filter(Boolean);
